import type { TranslationInterface } from '.';

export const BulgarianLanguage: TranslationInterface = {
  write_a_message_placeholder: 'Напишете съобщение...',
  your_issue_has_been_resolved: 'Вашият проблем е разрешен!',
  new_conversation: 'Нов разговор',
  welcome_screen_title: 'Добре дошли в нашия чат за поддръжка',
  welcome_screen_description:
    'Тук сме, за да помогнем! Започнете разговор и ще ви отговорим възможно най-скоро.',
  your_name_placeholder: 'Вашето име',
  your_email_placeholder: 'Вашият имейл адрес',
  start_chat_button: 'Свържете се с поддръжка',
  start_chat_button_loading: 'Свързване...',
  i_need_more_help: 'Имам нужда от повече помощ',
  this_was_helpful: 'Това беше полезно',
  optional: 'По избор',
  no_conversations_yet: 'Все още няма разговори',
  back_to_conversations: 'Назад към разговорите',
  closed_conversations: 'Затворени разговори',
  csat_title: 'Как мина разговорът ви?',
  csat_submitted_title: 'Оценихте разговора като',
  csat_feedback_placeholder: 'Кажете ни повече... (по желание)',
  follow_up_placeholder: 'Продължете…',
  companion_layout_label: 'Оформление',
  companion_layout_floating: 'Плаващ',
  companion_layout_sidebar: 'Странична лента',
  companion_layout_fullscreen: 'На цял екран',
  companion_close: 'Затвори',
  companion_history: 'История на разговорите',
  companion_expand_chat: 'Разгъване на чата',
  companion_sidebar_dock_label: 'Закачване',
  companion_sidebar_side_label: 'Страна',
  companion_sidebar_left: 'Ляво',
  companion_sidebar_right: 'Дясно',
  companion_resize_chat: 'Преоразмеряване на чата',
  scroll_to_bottom: 'Превъртане до края',
  thinking: 'Мисля…',
  running: 'Изпълнява се…',
  steps: 'стъпки',
  step_arguments: 'Аргументи',
  step_result: 'Резултат',
  attach_files:
    'Прикачете изображения, видеоклипове, PDF файлове или електронни таблици (максимален размер 25 MB)',
  mark_page_active:
    'Щракнете върху нещо на страницата, за да го маркирате — Esc за отказ',
  mark_page: 'Маркирайте нещо на страницата, за да попитате за него',
  stop_response: 'Спиране на отговора',
  copy_reply: 'Копирай отговора',
  mentions_empty: 'Няма съвпадения',
  copied: 'Копирано',
  send_message: 'Изпращане на съобщение',
  upload_failed: 'Неуспешно качване: {error}',
  remove_attachment: 'Премахване на прикачения файл',
  json_no_items: 'Няма елементи',
  json_no_data: 'Няма данни',
  json_no_chart_data: 'Няма данни за диаграма',
  json_unsupported: 'Не се поддържа: {type}',
  json_see_less: 'Покажи по-малко',
  json_phone_agent: 'Телефонен агент',
  json_phone_agent_test: 'Тест през уеб',
  page_context_remove: 'Премахни контекста на страницата',
  json_see_more: 'Покажи още {count}',
  queued_label: '{count} На опашката',
  remove_queued_message: 'Премахване на съобщението от опашката',
  send_queued_now: 'Изпрати съобщенията от опашката сега',
  turn_failed_message: 'Нещо се обърка и отговорът не пристигна.',
  turn_failed_retry: 'Опитайте отново',
  page_mark_hint: 'Щракнете върху нещо, за да го маркирате',
  page_mark_escape: 'Esc',
  page_mark_shape_box: 'Правоъгълник',
  page_mark_shape_circle: 'Кръг',
  page_mark_shape_arrow: 'Стрелка',
  page_mark_shape_bracket: 'Скоба',
  page_mark_shape_underline: 'Подчертаване',
  page_mark_shape_highlight: 'Маркиране',
  page_mark_shape_strike_through: 'Зачертаване',
  page_mark_shape_crossed_off: 'Кръстосано зачертаване',
  page_mark_shape_aria: 'Форма на маркировката: {shape}',
  page_mark_note_placeholder: 'Добавете бележка… (Enter за прикачване)',
  page_mark_attach: 'Прикачване на маркировката',
  page_mark_remove: 'Премахване на {label}',
  page_mark_region: 'Маркирана област',
  page_mark_default_message: 'Какво е това?',
  file_rejected: 'Типът на файла не се поддържа или файлът е твърде голям.',
  dictate: 'Диктувай',
  stop_dictation: 'Спри диктуването',
  dictation_mic_blocked: 'Разрешете достъп до микрофона, за да диктувате',
  dictation_unavailable: 'Диктуването не е налично в момента',
  questions_back: 'Назад',
  questions_next: 'Напред',
  questions_send: 'Изпрати',
  questions_type_answer: 'Ще напиша сам',
  questions_answer_placeholder: 'Напишете отговора си…',
  close_conversation_title: 'Затваряне на разговора',
  close_conversation_description:
    'Сигурни ли сте, че искате да затворите този разговор?',
  close_conversation_cancel: 'Не',
  close_conversation_confirm: 'Да',
  dialog_close: 'Затваряне',
  zoom_in: 'Увеличаване',
  zoom_out: 'Намаляване',
  reset_zoom: 'Нулиране на мащаба',
  support_chat_aria_label: 'Чат за поддръжка',
};
